import e from "./_isKeyable.js";
function n(r, a) {
  var t = r.__data__;
  return e(a) ? t[typeof a == "string" ? "string" : "hash"] : t.map;
}
export {
  n as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_getMapData.js
// module id = 297
// module chunks = 41